import { TaskContextMenu } from "./task-context-menu"
import { MoveToPosition } from "./move-to-position"

TaskContextMenu.plug(<MoveToPosition />)
